/**
 * Featured blog cards + article headers — merged into fr / es / ar in LanguageContext.
 * English copy lives in blogArticles.js.
 */

export const BLOG_I18N_FR = {
  featBlogWhyImport_title:
    'Pourquoi importer des produits en gros à prix abordable depuis la Turquie ? Guide stratégique pour les entreprises en croissance.',
  featBlogWhyImport_meta: 'juin 2026',
  featBlogWhyImport_tag: 'Approvisionnement & stratégie',
  featBlogWhyImport_excerpt:
    "Pour les entreprises qui cherchent à réduire leurs coûts tout en maintenant la qualité des produits, s'approvisionner en produits de gros dans le bon pays est une décision cruciale. Ces dernières années, la Turquie est devenue l'un des hubs d'approvisionnement les plus attractifs pour les acheteurs internationaux à la recherche de produits abordables mais de haute qualité.",

  featBlogFood_title:
    'Importer des produits alimentaires depuis la Turquie : un choix pertinent pour les acheteurs en gros',
  featBlogFood_meta: 'juin 2026',
  featBlogFood_tag: 'Alimentaire & gros',
  featBlogFood_excerpt:
    'Pour un approvisionnement alimentaire fiable et économique, la Turquie est devenue un pivot d\'achat mondial. Son agriculture structurée et ses standards industriels modernes permettent d\'offrir une large gamme de produits de base à des prix compétitifs.',
};

export const BLOG_I18N_ES = {
  featBlogWhyImport_title:
    '¿Por qué importar productos al por mayor baratos desde Turquía? Guía estratégica para empresas en crecimiento',
  featBlogWhyImport_meta: 'junio 2026',
  featBlogWhyImport_tag: 'Abastecimiento y estrategia',
  featBlogWhyImport_excerpt:
    'Para reducir costes sin renunciar a la calidad, elegir el país adecuado para comprar al por mayor es clave. En los últimos años, Turquía se ha consolidado como uno de los hubs más atractivos para compradores internacionales que buscan mercancías asequibles y de gran calidad.',

  featBlogFood_title:
    'Importar productos alimentarios desde Turquía: una decisión inteligente para compradores mayoristas',
  featBlogFood_meta: 'junio 2026',
  featBlogFood_tag: 'Alimentación y mayoreo',
  featBlogFood_excerpt:
    'Si busca un suministro alimentario fiable y rentable, Turquía se ha convertido en un centro global de compras. Su sector agrícola desarrollado y sus estándares de producción modernos ofrecen una amplia gama de productos básicos a precios competitivos.',
};

export const BLOG_I18N_AR = {
  featBlogWhyImport_title:
    'لماذا تستورد منتجات الجملة الرخيصة من تركيا؟ دليل استراتيجي للشركات النامية',
  featBlogWhyImport_meta: 'يونيو ٢٠٢٦',
  featBlogWhyImport_tag: 'التوريد والاستراتيجية',
  featBlogWhyImport_excerpt:
    'لخفض التكاليف مع الحفاظ على الجودة، اختيار البلد المناسب لتوريد الجملة قرار حاسم. في السنوات الأخيرة برزت تركيا كواحدة من أكثر وجهات الشراء جاذبية للمشترين الدوليين الذين يبحثون عن بضائع بأسعار مناسبة وجودة عالية.',

  featBlogFood_title:
    'استيراد المنتجات الغذائية من تركيا: خيار ذكاء لمشتري الجملة',
  featBlogFood_meta: 'يونيو ٢٠٢٦',
  featBlogFood_tag: 'المواد الغذائية والجملة',
  featBlogFood_excerpt:
    'لمن يبحث عن إمداد غذائي موثوق وذي تكلفة معقولة، أصبحت تركيا مركز توريد عالميا قويا. بفضل قطاع زراعي متطور ومعايير إنتاج حديثة، توفر مجموعة واسعة من السلع الأساسية بأسعار تنافسية.',
};
